import moment from 'moment-timezone';

/**
 * Converts dateTime string value to moment object'
 * If the timestamp can't be formatted, then 'null' is returned
 * @param timestamp - UTC Timestamp
 * @returns Moment.moment or null
 */

export function dateAndTime(timestamp: string): moment.Moment | null {
    if (timestamp === null) return null;
    const instance = moment(timestamp, ['YYYY-MM-DDTHH:mm', 'YYYY-MM-DD hh:mm A', 'YYYY-MM-DD', 'THH:mm', 'hh:mm A']);
    return instance.isValid() ? instance : null;
}

export default dateAndTime;

